import { Component, input, OnInit } from '@angular/core';

@Component({
  selector: 'app-btn-whatsapp',
  standalone: true,
  imports: [],
  templateUrl: './btn-whatsapp.component.html',
  styleUrl: './btn-whatsapp.component.css',
})
export class BtnWhatsappComponent implements OnInit {
  phoneNumber = input<string>('+1234567890');
  btnText = input<string>('Send Message');
  isDisabled = input<boolean>(false);
  icon = input<string>('fab fa-whatsapp');
  colors = input<string>('bg-primary-500 hover:bg-primary-300 text-white');
  message = input.required<string>();
  whatsappLink: string | undefined;

  constructor() {}

  ngOnInit(): void {
    this.whatsappLink = `https://api.whatsapp.com/send?phone=${
      this.phoneNumber
    }&text=${encodeURIComponent(this.message())}`;
  }
}
